import React from 'react';
import { LayoutGrid, Twitter, Github, Linkedin } from 'lucide-react';
const FOOTER_LINKS = {
  Product: ['Features', 'Integrations', 'Pricing', 'Changelog', 'Docs'],
  Resources: ['Templates', 'Blog', 'Community', 'Help Center', 'API Reference'],
  Company: ['About', 'Careers', 'Customers', 'Contact', 'Partners'],
  Legal: ['Privacy Policy', 'Terms of Service', 'Security', 'Cookie Policy']
};
export function Footer() {
  return <footer className="bg-zinc-950 border-t border-white/5 pt-16 pb-8" data-id="element-76">
      <div className="max-w-7xl mx-auto px-6" data-id="element-77">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-16" data-id="element-78">
          {Object.entries(FOOTER_LINKS).map(([category, links]) => <div key={category} data-id="element-79">
              <h4 className="font-semibold text-white mb-4" data-id="element-80">{category}</h4>
              <ul className="space-y-3" data-id="element-81">
                {links.map(link => <li key={link} data-id="element-82">
                    <a href="#" className="text-sm text-zinc-400 hover:text-white transition-colors" data-id="element-83">
                      {link}
                    </a>
                  </li>)}
              </ul>
            </div>)}
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-84">
          <div className="flex items-center gap-2 text-zinc-400" data-id="element-85">
            <LayoutGrid size={18} data-id="element-86" />
            <span className="font-semibold text-white" data-id="element-87">Sheets2Board</span>
            <span className="text-sm ml-2" data-id="element-88">© {new Date().getFullYear()}</span>
          </div>

          <div className="flex items-center gap-4 text-zinc-400" data-id="element-89">
            <a href="#" className="hover:text-white transition-colors" data-id="element-90">
              <Twitter size={18} data-id="element-91" />
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-92">
              <Github size={18} data-id="element-93" />
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-94">
              <Linkedin size={18} data-id="element-95" />
            </a>
          </div>
        </div>
      </div>
    </footer>;
}